import { useContent } from "../../../context/ContentContext";
import { Editable, Sortable } from "../../../context/design";

const icons = ["ri-heart-3-line", "ri-group-line", "ri-seedling-line"];

export default function TargetAudienceSection() {
  const { target } = useContent();

  return (
    <section id="target" className="relative py-20 md:py-32 w-full bg-sky-50">
      <div className="w-full px-4 sm:px-6 lg:px-12 xl:px-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-sky-200 mb-8">
            <i className="ri-user-heart-line text-sky-600"></i>
            <Editable as="span" id="target.badge" label="Auszeichnung" className="text-sm font-medium text-sky-800">{target.badge}</Editable>
          </div>
          <Editable as="h2" id="target.title" label="Überschrift" className="text-3xl sm:text-4xl md:text-5xl font-bold text-sky-950 leading-tight mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>
            {target.title}
          </Editable>
          <Editable as="p" id="target.description" label="Beschreibung" className="text-lg md:text-xl text-sky-800/80 leading-relaxed max-w-2xl mx-auto mb-12">{target.description}</Editable>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
            {target.cards.map((card, i) => (
              <Sortable key={i} path={["target", "cards"]} index={i} className="bg-white rounded-3xl p-6 md:p-8 text-left border border-sky-100 hover:border-sky-200 transition-colors">
                <div className="w-12 h-12 bg-sky-100 rounded-2xl flex items-center justify-center mb-5">
                  <i className={`${icons[i % icons.length]} text-xl text-sky-700`}></i>
                </div>
                <Editable as="h3" id={`target.cards.${i}.title`} label={`Karte ${i + 1} – Titel`} className="text-lg font-bold text-sky-900 mb-3">{card.title}</Editable>
                <Editable as="p" id={`target.cards.${i}.text`} label={`Karte ${i + 1} – Text`} className="text-sm text-sky-700/80 leading-relaxed">{card.text}</Editable>
              </Sortable>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
